const planos = [
    //{
    //    modalidade:"musculação",
    //    tipo:"",
    //    tx_adesão:"Grátis",
    //    duração:"1 mês",
    //    pagamento:"À vista",
    //    parcela:"R$70,00",
    //    valorTotal:70,
    //    source:""
    //},

    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( 2x/semana ) - mensal",
        tx_adesão:"Grátis",
        duração:"1 mês",
        pagamento:"À vista",
        parcela:"R$210,00",
        valorTotal:210,
        source:"https://venda.nextfit.com.br/43042593-ef97-40a1-a792-94b4db502cd8"
    },
    
    //{
    //    modalidade:"lutas(jiu jitsu / boxe)",
    //    tipo:"- 2x/semana - semestral",
    //    tx_adesão:"Grátis",
    //    duração:"6 meses",
    //    pagamento:"Em até 6x",
    //    parcela:"R$180,00",
    //    valorTotal:1080,
    //    acessos:""
    //},

    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( 2x/semana ) - anual",
        tx_adesão:"Grátis",
        duração:"12 meses",
        pagamento:"Em até 12x",
        parcela:"R$170,00",
        valorTotal:2040,
        source:"https://venda.nextfit.com.br/ac23c9c6-7cdc-43d3-9845-9f9abb2470d4"
    },

    //{
    //    modalidade:"lutas(jiu jitsu / boxe)",
    //    tipo:"- 2x/semana - trimestral",
    //    tx_adesão:"Grátis",
    //    duração:"3 meses",
    //    pagamento:"Em até 3x",
    //    parcela:"R$190,00",
    //    valorTotal:570,
    //    source:""
    //},
//
//
    //{
    //    modalidade:"promo - lutas(jiu jitsu + boxe)",
    //    tipo:"- recorrente",
    //    tx_adesão:"Grátis",
    //    duração:"3 meses",
    //    pagamento:"Em até 3x",
    //    parcela:"R$299,00",
    //    valorTotal:897,
    //    source:""
    //},

    {
        modalidade:"PROMO Plano Lutas ",
        tipo:" ( 2x/Semana ) - recorrente",
        tx_adesão:"Grátis",
        duração:"12 meses",
        pagamento:"Em até 12x",
        parcela:"R$189,00",
        valorTotal:2268,
        source:"https://venda.nextfit.com.br/f67a9db7-a1aa-4e77-924e-834f624708e6/contratos"
    }



    
    

    
]

export default planos;